import React, {useState} from 'react';
import AdminService from '../services/adminService';

export const AdminContext = React.createContext();

const AdminContextProvider = ({ children }) => {
  const [pending, setPending] = useState(false);
  const [addUserPending, setAddUserPending] = useState(false);
  const [changePasswordPending, setChangePasswordPending] = useState(false);
  const [error, setError] = useState(false);
  const [users, setUsers] = useState([]);
  const [usersForDropdowns, setUsersForDropdowns] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState({});

  const getUsers = async (size, page) => {
    setError(false);
    setPending(true);
    const responseObj = await AdminService.getUsers(size, page);

    if (responseObj.type === 'Error') {
      setError(true);
    } else {
      setUsers(responseObj._embedded.users);
      setPaginationInfo(responseObj.page);
    }

    setPending(false);

    return responseObj;
  };

  const getUsersForDropdowns = async () => {
    setError(false);
    setPending(true);
    const responseObj = await AdminService.getUsersForDropdowns();

    if (responseObj.type === 'Error') {
      setError(true);
    } else {
      setUsersForDropdowns(responseObj._embedded.users);
    }

    setPending(false);

    return responseObj;
  };

  const addUser = async formValues => {
    setError(false);
    setAddUserPending(true);

    let payload = {...formValues};

    Object.keys(payload).forEach(key => {
      payload[key] = payload[key].id ? payload[key].id : payload[key];
    });

    const response = await AdminService.addNewUser(payload);

    if (response !== 200) {
      setError(true);
      setAddUserPending(false);
      return response;
    }

    setAddUserPending(false);
    return response;
  };

  const updateUser = async (formValues, id) => {
    setError(false);
    setAddUserPending(true);

    let payload = {...formValues};

    Object.keys(payload).forEach(key => {
      payload[key] = payload[key].id ? payload[key].id : payload[key];
    });

    payload.id = id;

    const response = await AdminService.updateUser(payload);

    if (response !== 200) {
      setError(true);
      setAddUserPending(false);
      return response;
    }

    setAddUserPending(false);
    return response;
  };

  const deleteUser = async id => {
    setError(false);
    setAddUserPending(true);

    const response = await AdminService.deleteUser(id);

    if (response !== 204) {
      setError(true);
      setAddUserPending(false);
      return response;
    }

    setAddUserPending(false);
    return response;
  };

  const changePasswordByAdmin = async (payload) => {
    setError(false);
    setChangePasswordPending(true);
    const response = await AdminService.changePasswordByAdmin(payload);

    if (response !== 200) {
      setError(true);
      setChangePasswordPending(false);
      return response;
    }

    setChangePasswordPending(false);

    return response;
  };

  const changePasswordByUser = async payload => {
    setError(false);
    setChangePasswordPending(true);
    const response = await AdminService.changePasswordByUser(payload);

    if (response !== 200) {
      setError(true);
      setChangePasswordPending(false);
      return response;
    }

    setChangePasswordPending(false);

    return response;
  };

  return (
    <AdminContext.Provider
      value={{
        pending,
        addUserPending,
        changePasswordPending,
        error,
        users,
        paginationInfo,
        usersForDropdowns,
        getUsers,
        addUser,
        updateUser,
        deleteUser,
        changePasswordByAdmin,
        changePasswordByUser,
        getUsersForDropdowns
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export default AdminContextProvider;
